import { Close } from "@mui/icons-material";
import { Button, CircularProgress, Dialog } from "@mui/material";
import { useState } from "react";

import useService from "../../../../../../../../hooks/useService";
import LoadingIndicator from "../../../../../../../global/LoadingIndicator";
import { UI_STATES } from "../utils/strings";

import DownloadConfirmation from "./DownloadConfirmation";

const ReportModal = ({ setOpenModal, reportData, reportId, filters }) => {
  const tabularReportRepository = useService("repositories/tabular-report-repository");
  const reportName = reportData?.displayName || "";
  const resolvedReportId = reportId ?? reportData?.id ?? reportData?.pk;
  const [contentToShow, setContentToShow] = useState(UI_STATES.INITIAL);

  const isConfirmed = (confirmed) => {
    if (confirmed) {
      setContentToShow(UI_STATES.LOADING);
      handleExportReport();
    }
  };

  const getDialogContentUI = (content) => {
    switch (content) {
      case UI_STATES.INITIAL: {
        return (
          <DownloadConfirmation
            reportName={reportName}
            reportId={resolvedReportId}
            closeModal={handleClose}
            setConfirmation={isConfirmed}
          />
        );
      }
      case UI_STATES.LOADING: {
        return (
          <div
            id="DownloadReport-Content-In-Progress"
            data-testid="DownloadReport-Content-In-Progress"
          >
            <h1 className={`text-center text-xl font-bold uppercase text-purple-600`}>
              Download In Progress
            </h1>
            <div className="py-4">
              <CircularProgress color="secondary" />
            </div>
          </div>
        );
      }
      case UI_STATES.SUCCESS: {
        return (
          <div id="DownloadReport-Content-Success" data-testid="DownloadReport-Content-Success">
            <h1 className={`text-center text-xl font-bold uppercase text-purple-600`}>
              Download Complete
            </h1>
            <div className="py-4 text-center">
              You should receive an email shortly with a link to your download.
            </div>
            <Button variant="contained" className="bg-green-600" onClick={() => handleClose()}>
              OK
            </Button>
          </div>
        );
      }
      case UI_STATES.ERROR: {
        return (
          <div id="DownloadReport-Content-Error" data-testid="DownloadReport-Content-Error">
            <div className="py-4">Error. Please Try Again Later.</div>
            <Button variant="contained" className="bg-red-600" onClick={() => handleClose()}>
              OK
            </Button>
          </div>
        );
      }
      default: {
        return <LoadingIndicator isLoading />;
      }
    }
  };

  const buildExportParams = (rawFilters) => {
    const params = {};

    if (!rawFilters) {
      return params;
    }

    if (rawFilters instanceof URLSearchParams) {
      rawFilters.forEach((value, key) => {
        if (key === "limit" || key === "offset") {
          return;
        }
        if (value === null || value === "") {
          return;
        }
        params[key] = value;
      });
      return params;
    }

    if (typeof rawFilters === "object") {
      Object.entries(rawFilters).forEach(([key, value]) => {
        if (key === "limit" || key === "offset") {
          return;
        }
        if (value === null || value === "") {
          return;
        }
        params[key] = value;
      });
    }

    return params;
  };

  async function handleExportReport() {
    try {
      const paramObj = buildExportParams(filters);
      await tabularReportRepository.export(resolvedReportId, paramObj);
      setContentToShow("SUCCESS");
    } catch (error) {
      setContentToShow("ERROR");
      return error;
    }
  }

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <Dialog open>
      <div className="outer p-2 text-center">
        <div className="text-right">
          <Button onClick={(e) => handleClose(e)}>
            <Close />
          </Button>
        </div>

        <div className="p-2 text-center" data-testid="AddTeams-Dialog-Content">
          {getDialogContentUI(contentToShow)}
        </div>
      </div>
    </Dialog>
  );
};
export default ReportModal;
